import { GenericErrorBoundary } from "./GenericErrorBoundary";
import {
  BaseErrorBoundaryProps,
  TerminalContext,
  createTerminalState,
} from "./types";

interface Props extends BaseErrorBoundaryProps, TerminalContext {}

export function TerminalPageErrorBoundary(props: Props) {
  const { children, onError, ...contextProps } = props;

  return (
    <GenericErrorBoundary
      componentName="TerminalPage"
      errorBoundaryName="TerminalPageErrorBoundary"
      componentType="TerminalChat"
      title="Terminal Error"
      description="The terminal chat encountered an error. Please reload the page to continue."
      buttonText="Reload Page"
      onError={onError}
      context={contextProps}
      stateData={createTerminalState(contextProps)}
    >
      {children}
    </GenericErrorBoundary>
  );
}
